import { memo } from "react";

import useMainNavigationPrimaryItems from "components/MainNavigation/hooks/usePrimaryItems";
import useMainNavigationExternalRevealPinTriggers from "components/MainNavigation/hooks/useExternalRevealPinTriggers";
import MainNavigationListItems from "components/MainNavigation/components/elements/ListItems";

const MainNavigationPrimaryItems = () => {
  const { navigationItems } = useMainNavigationPrimaryItems();

  useMainNavigationExternalRevealPinTriggers(navigationItems);

  return <MainNavigationListItems items={navigationItems} />;
};

export default memo(MainNavigationPrimaryItems);
